export default "__VITE_ASSET__cf95a416__"